/* Export Utility */
import { CsvBuilder } from 'filefy';
import moment from 'moment';
import get from 'lodash/get';

// export data from table config to CSV
const exportCsv = (allColumns, allData) => {
  const columns = allColumns.filter((columnDef) => columnDef.export !== false);
  const exportedData = allData.map(
    (rowData) => columns.map((columnDef) => get(rowData, columnDef.field)),
  );
  new CsvBuilder(`filename_${moment().format('YYYY-MM-DDTHHmmss')}.csv`)
    .setDelimeter(',')
    .setColumns(columns.map((columnDef) => columnDef.title_export))
    .addRows(exportedData)
    .exportFile();
};

export default exportCsv;
